package nl.volleyanalyzer.web.controller

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import nl.volleyplanner.web.MainApp
import nl.volleyplanner.web.launchAsync

object PouleMatchesDataManager {
    private val pouleMatchesDataFlows = mutableMapOf<String, MutableStateFlow<PouleMatchesData?>>()

    fun subscribeToPoule(pouleId: String) : StateFlow<PouleMatchesData?> {
        val currentFlow = pouleMatchesDataFlows[pouleId]
        if (currentFlow == null) {
            pouleMatchesDataFlows[pouleId] = MutableStateFlow(null)
            launchAsync { MainApp.volleyanalyzerApiClient.getPouleMatches(pouleId, false) }
                .onComplete { response -> pouleMatchesDataFlows.getValue(pouleId).value = PouleMatchesData(response) }
        }
        return pouleMatchesDataFlows.getValue(pouleId)
    }
}